export const bootstrapVariantNames = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'dark', 'light'];

type BaseVariantType = (typeof bootstrapVariantNames)[number];

export type BootstrapVariant = BaseVariantType | (string & {});
